<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     模型管理-图标管理-图标编辑
  | @Version:   2019-04-18  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="dev-icon-post">
    <el-dialog
      :title="iconid ? '编辑图标' : '创建图标'"
      :visible.sync="dialogShow"
      width="600px"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      append-to-body
      @close="onDialogClose">
      <div v-loading="loading" style="padding-left: 40px;padding-right: 40px;">
        <el-form
          ref="iconForm"
          :model="icon"
          status-icon
          :rules="rules"
          label-position="left"
          label-width="120px">
          <el-form-item label="名称" prop="icon_title">
            <el-input v-model="icon.icon_title" />
          </el-form-item>
          <el-form-item label="图标" prop="icon_url">
            <f-image-card-uploader :files="iconArr" :limit="1" :url="uploadUrl" aimPath="dev/icon/" @change="onIconChange" />
          </el-form-item>
          <el-form-item prop="icon_url_2">
            <span slot="label">图标2
              <el-tooltip
                placement="top">
                <div slot="content">当参数为开关型，<br />值为0时，显示图标1；<br />值为1时，显示图标2。</div>
                <span class="font-md middle text-muted"><i class="iconfont icon-circle-question"></i></span>
              </el-tooltip>
            </span>
            <f-image-card-uploader :files="icon2Arr" :limit="1" :url="uploadUrl" aimPath="dev/icon/" @change="onIcon2Change" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" :loading="posting" @click="submit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FImageCardUploader from '@/components/FImageCardUploader'
import { postIconApi } from '@/api/iconApi'

export default {
  name: 'DevIconPost',
  components: { FImageCardUploader },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    iconid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      posting: false,
      uploadUrl: process.env.VUE_APP_API_HOST + '?c=utility&a=file&do=upload',
      icon: {
        icon_type: 1,
        icon_title: '',
        icon_url: '',
        icon_url_2: ''
      },
      rules: {
        icon_title: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        icon_url: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },
    iconArr() {
      const arr = []
      if (!this.icon.icon_url) {
        return []
      }
      arr.push({
        url: this.icon.icon_url
      })
      return arr
    },
    icon2Arr() {
      const arr = []
      if (!this.icon.icon_url_2) {
        return []
      }
      arr.push({
        url: this.icon.icon_url_2
      })
      return arr
    }
  },
  created() {
    if (this.iconid) {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      postIconApi({ iconid: this.iconid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.icon = Object.assign(this.icon, res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onDialogClose() {
      this.$refs['iconForm'].resetFields()
    },
    onIconChange(Arr) {
      this.icon.icon_url = Arr.length === 0 ? '' : Arr[0].url
    },
    onIcon2Change(Arr) {
      this.icon.icon_url_2 = Arr.length === 0 ? '' : Arr[0].url
    },
    submit() {
      this.$refs['iconForm'].validate((valid) => {
        if (valid) {
          this.posting = true
          postIconApi(this.icon).then(res => {
            this.posting = false
            if (!res.errno) {
              this.$message.success(res.message)
              this.dialogShow = false
              this.$emit('success')
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    }
  }
}
</script>

